import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconEyeLine } from '@instructure/ui-icons';
import { Button } from '@instructure/ui-buttons';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { Focusable } from '@instructure/ui-focusable';
import { Popover } from '@instructure/ui-popover';
import { View } from '@instructure/ui-view';
import t from '@instructure/quiz-i18n/format-message';
export var PreviewButton = /*#__PURE__*/function (_Component) {
  function PreviewButton() {
    var _this2;
    _classCallCheck(this, PreviewButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, PreviewButton, [].concat(args));
    _defineProperty(_this2, "state", {
      showPopover: false
    });
    _defineProperty(_this2, "popoverShow", function () {
      _this2.setState({
        showPopover: true
      });
    });
    _defineProperty(_this2, "popoverHide", function () {
      _this2.setState({
        showPopover: false
      });
    });
    return _this2;
  }
  _inherits(PreviewButton, _Component);
  return _createClass(PreviewButton, [{
    key: "renderEnabled",
    value: function renderEnabled() {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.onClick,
        color: "primary-inverse",
        renderIcon: IconEyeLine,
        "data-automation": "sdk-preview-button"
      }, /*#__PURE__*/React.createElement(AccessibleContent, {
        alt: t('Preview as a student')
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small"
      }, t('Preview'))));
    }
  }, {
    key: "renderDisabled",
    value: function renderDisabled() {
      var _this3 = this;
      var accessibleLabel = this.props.isEditing ? t('Preview (disabled - Preview not available while questions are being edited.)') : t('Preview (disabled - Quiz has no questions)');
      var popoverLabel = this.props.isEditing ? t('Preview not available while questions are being edited.') : t('Quiz has no questions');
      return /*#__PURE__*/React.createElement(Focusable, null, function (_ref) {
        var focused = _ref.focused,
          focusVisible = _ref.focusVisible;
        return /*#__PURE__*/React.createElement(Popover, {
          on: ['hover', 'focus'],
          isShowingContent: focused || _this3.state.showPopover,
          shouldCloseOnDocumentClick: true,
          shouldReturnFocus: false,
          onMouseOver: _this3.popoverShow,
          onFocus: _this3.popoverShow,
          onMouseOut: _this3.popoverHide,
          onBlur: _this3.popoverHide,
          renderTrigger: /*#__PURE__*/React.createElement(View, {
            withFocusOutline: focusVisible,
            as: "div"
          }, /*#__PURE__*/React.createElement(Button, {
            disabled: true,
            color: "primary-inverse",
            renderIcon: IconEyeLine
          }, /*#__PURE__*/React.createElement(AccessibleContent, {
            alt: accessibleLabel
          }, /*#__PURE__*/React.createElement(Text, {
            size: "small"
          }, t('Preview')))))
        }, /*#__PURE__*/React.createElement(View, {
          as: "div",
          padding: "small"
        }, /*#__PURE__*/React.createElement(Text, {
          color: "primary"
        }, popoverLabel)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props.isEditing || !this.props.hasQuestions;
      return disabled ? this.renderDisabled() : this.renderEnabled();
    }
  }]);
}(Component);
_defineProperty(PreviewButton, "propTypes", {
  onClick: PropTypes.func.isRequired,
  hasQuestions: PropTypes.bool,
  isEditing: PropTypes.bool
});
_defineProperty(PreviewButton, "defaultProps", {
  hasQuestions: true,
  isEditing: false
});
export default PreviewButton;